import Swal from "sweetalert2";
import { Router } from "@angular/router";

interface NotificationsOptions {
  confirmButtonText?: string;
  html?: string;
}

export function showSucess(title:string,text: string, options?: NotificationsOptions){
    Swal.fire({
        text: text,
        title: title,
        html: options?.html,
        icon: 'success',
        iconColor: '#479E45',
        showConfirmButton: true,
        confirmButtonText: options?.confirmButtonText || 'Entendi',
        confirmButtonColor: '#303678',
        showCloseButton: true,
    })
}

export function showError(title:string, text: string, options?: NotificationsOptions){
    Swal.fire({
        title: title,
        text: text,
        html: options?.html,
        showConfirmButton: true,
        confirmButtonColor: '#303678',
        confirmButtonText: options?.confirmButtonText || 'Entendi',
        showCloseButton: true,
        icon: 'error',
        iconColor: '#DC362E',
    })
}

export function showErrorViaArray(title:string, errors: string[], html?: string){
    const mensagem = errors.join(". ");
    Swal.fire({
        title: title,
        text: mensagem,
        html: html,
        showConfirmButton: true,
        confirmButtonColor: '#303678',
        showCloseButton: true,
        icon: 'error',
        iconColor: '#DC362E',
    })
}

export function showErrorAndNavigateToHome(router: Router, title:string,text: string, html?: string){
  Swal.fire({
    title: title,
    text: text,
    html: html,
    showConfirmButton: true,
    confirmButtonColor: '#303678',
    showCloseButton: true,
    icon: 'error',
    iconColor: '#DC362E',
  }).then((result) => {
    // Redireciona para a home quando o alerta for fechado
    if (result.isConfirmed || result.isDismissed) {
      router.navigate(["login"]);
    }
  });
}

export function showNotification(title:string,text: string, html?: string, options?: NotificationsOptions){
    Swal.fire({
        text: text,
        title: title,
        html: html,
        iconHtml: '<span class="material-icons-outlined notification-icon">contact_page</span>',
        customClass: {
          icon: 'custom-icon'
        },
        iconColor: '#303678',
        showConfirmButton: true,
        confirmButtonColor: '#303678',
        confirmButtonText: options?.confirmButtonText || 'Entendi',
        showCloseButton: true,
    })
}

export function showWarning(title:string,text: string, html?: string){
    Swal.fire({
        text: text,
        title: title,
        html: html,
        icon: 'warning',
        iconColor: '#d97e03',
        showConfirmButton: true,
        confirmButtonColor: '#303678',
        showCloseButton: true,
    })
}

export function showDefaultError(error: string){
    Swal.fire({
        icon: 'error',
        iconColor: '#DC362E',
        html: error['error']['data']['detalhesErro'],
        showConfirmButton: true,
        confirmButtonColor: '#303678',
        showCloseButton: true,
    })
}
